import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format date as YYYY-MM-DD without timezone conversion
 * This ensures dates are formatted in local timezone, preventing
 * date shifts that occur with toISOString() in timezones ahead of UTC
 * 
 * @param {Date} date - The date to format
 * @returns {string} Formatted date string (YYYY-MM-DD)
 */
export function formatDateOnly(date) {
  if (!date || !(date instanceof Date)) {
    throw new Error("formatDateOnly requires a valid Date object");
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}